@if (action(); as action) {
  <div class="flex flex-col gap-2 rounded-lg border border-primary-100 bg-[var(--p-surface-50)] p-3">

    <div class="flex items-center gap-2">
      <span aria-hidden="true" class="pi pi-sparkles text-primary-500 text-sm"></span>
      <span class="text-sm font-bold">{{ 'ai.action.' + action.type | translate }}</span>
    </div>

    <dl class="flex flex-col gap-1">
      @for (field of fields(); track field.label) {
        <div class="flex gap-2 text-sm">
          <dt class="w-28 shrink-0 text-surface-500">{{ field.label | translate }}</dt>
          <dd class="flex-1 break-words">
            @if (field.items; as items) {
              <ul class="list-disc pl-4">
                @for (item of items; track $index) {
                  <li>{{ item }}</li>
                }
              </ul>
            } @else {
              {{ field.isKey ? (field.value | translate) : field.value }}
            }
          </dd>
        </div>
      }
    </dl>

    @if (isPending()) {
      <div class="flex justify-end gap-2">
        <elcia-button (onClick)="cancelled.emit(message())"
                      [disabled]="isBusy()"
                      [label]="'action.cancel' | translate"
                      [severity]="'secondary'"
                      [size]="'small'"/>
        <elcia-button (onClick)="confirmed.emit(message())"
                      [disabled]="isBusy()"
                      [icon]="'check'"
                      [label]="'action.confirm' | translate"
                      [size]="'small'"/>
      </div>
    } @else {
      <elcia-badge [tone]="isConfirmed() ? 'success' : 'neutral'" class="self-end">
        {{ (isConfirmed() ? 'ai.action-confirmed' : 'ai.action-cancelled') | translate }}
      </elcia-badge>
    }
  </div>
}
